"use client";

import { usePathname } from "next/navigation";

import { Footer } from "@/components/header_footer/Footer";
import { Navbar } from "@/components/header_footer/Navbar";

interface ConditionalLayoutProps {
  children: React.ReactNode;
}

export function ConditionalLayout({ children }: ConditionalLayoutProps) {
  const pathname = usePathname();
  // /listing/[slug]/[id]/qr is a special case where we don't want to show the navbar or footer
  const isHidden = pathname === "/signin" || pathname.endsWith("/qr");

  return (
    <>
      {!isHidden && <Navbar />}
      {children}
      {!isHidden && <Footer />}
    </>
  );
}
